import {Titular} from './afiliaciones/titular.model';
import {SolicitudTiposEnum} from './afiliaciones/solicitud-tipos.enum';
import {Solicitud} from './solicitud.model';
import {Beneficiario} from './afiliaciones/beneficiario.model';
import { SolicitudContratoModel } from './solicitud-contrato.model';

export class SolicitudCambioEstadoCivil extends SolicitudContratoModel {

  static instance() {
    return new this();
  }

  static mapearDesdeFormularioCEC(
    formAfiliadoModel: object,
    formConyugeModel: any,
    formEmpresaModel: any,
    formularioBeneficiarioModel: Array<any>
  ) {
    const solicitudTipo = SolicitudTiposEnum.CEC;
    const afiliacionDto = SolicitudCambioEstadoCivil.instance();
    afiliacionDto.beneficiarios = [];
    afiliacionDto.titular = Titular.mapearDesdeFormularioCEC(formAfiliadoModel);
    afiliacionDto.solicitud = Solicitud.mapearDesdeFormularioCEC(solicitudTipo, formAfiliadoModel);
    afiliacionDto.conyuge = formConyugeModel;
    afiliacionDto.empresa = formEmpresaModel;
    if (formularioBeneficiarioModel.length > 0) {
      afiliacionDto.beneficiarios = Beneficiario.mapearDesdeFormularioDiscp(solicitudTipo, formularioBeneficiarioModel);
    } else {
      afiliacionDto.beneficiarios = [];
    }
    return afiliacionDto;
  }
}
